import axios from "axios"
import {DBModel, PagingType, SortByType} from "@backend/types"


type ApiRequestOptions = {
    type: string,
    dispatch: (props: any) => {}
}

export type ListQueryOptionsType = {
    limit?: number,
    page?: number,
    sortBy?: SortByType[]
}

export type ListQueryType = {
    searchText?: string,
    find?: any,
    select?: string
}

export function apiRequest<Type>(axiosPro, options?: ApiRequestOptions): Promise<Type> {
    return new Promise((res, rej) => {
        axiosPro
            .then(response => {
                if (response.error) {
                    return rej(response.error)
                }
                if (options?.type && options?.dispatch) {
                    options.dispatch({
                        type: options.type,
                        payload: response
                    })
                }
                res(response as Type)
            })
            .catch(err => {
                debugger
                rej(err)
            })
    })
}

export class ClientService {
    resourceUrl: string
    readonly name: string
    private readonly url: string = "/api"
    private readonly path: string

    constructor(name: string, path?: string) {
        this.name = name
        this.path = path || `${name}s`
        this.resourceUrl = `${this.url}/${this.path || this.name}`
    }
}


export interface IApiCalls<T> {
    create: (data: T) => Promise<T>
    createBatch: (data: T[]) => Promise<DBModel["_id"][]>
    list: (query: ListQueryType, options?: ListQueryOptionsType) => Promise<T[]>
    listWithPager: (query: ListQueryType, options?: ListQueryOptionsType) => Promise<PagingType<T>>
    getOne: (id: DBModel["_id"], options?: any) => Promise<T>
    update: (id: DBModel["_id"], data: Partial<Omit<T, "_id">>, options?: any) => Promise<T>
    delete: (id: DBModel["_id"], options?: any) => Promise<string>,
    search: (searchText: string) => Promise<T[]>
}

export interface IApiCallService<T extends DBModel> {
    apiCalls: IApiCalls<T>
}

export class ApiCallService<T extends DBModel> extends ClientService implements IApiCallService<T> {

    apiCalls: IApiCalls<T> = {
        create: (data: T) => apiRequest<T>(axios.post(this.resourceUrl, data)),
        createBatch: (data: T[]) => apiRequest<string[] | DBModel["_id"][]>(axios.post(`${this.resourceUrl}/batch`, data)),
        list: (query: ListQueryType = {}, options?: ListQueryOptionsType): Promise<T[]> => apiRequest<T[]>(axios.get(this.resourceUrl, {
            params: {...query, ...(options || {}), page: 0}
        })),
        listWithPager: (query: ListQueryType = {}, options?: ListQueryOptionsType): Promise<PagingType<T>> => apiRequest<PagingType<T>>(axios.get(this.resourceUrl, {
            params: {...query, ...(options || {})}
        })),
        getOne: (id) => apiRequest<T>(axios.get(`${this.resourceUrl}/${id}`)),
        update: (id, data, options) => apiRequest<T>(axios.put(`${this.resourceUrl}/${id}`, data)),
        delete: (id, options) => apiRequest<string>(axios.delete(`${this.resourceUrl}/${id}`, options)),
        search: (searchText) => apiRequest<T[]>(axios.get(`${this.resourceUrl}/search`, {
            params: {
                searchText
            }
        }))
    }

    constructor(name: string, path?: string) {
        super(name, path)
    }
}

export interface IActions<T> {
    listWithPager: (query?: ListQueryType, options?: ListQueryOptionsType) => any,
    update: (id: string | DBModel["_id"], data: Partial<Omit<T, "_id">>) => any,
    create: (data: T) => any,
    delete: (id: string) => any,
    clear: () => any
}

export type ActionTypesType = {
    GET: string,
    LIST: string,
    CREATE: string,
    UPDATE: string,
    DELETE: string,
    CLEAR: string,
    [key: string]: string
}

export class ActionService<T extends DBModel> extends ClientService {

    actionTypes: ActionTypesType

    actions: IActions<T> = {

        listWithPager: (query: ListQueryType = {}, options?: ListQueryOptionsType) => dispatch => apiRequest<PagingType<T>>(axios.get(this.resourceUrl, {
            params: {...query, ...(options || {})}
        }), {
            type: this.actionTypes.LIST,
            dispatch
        }),
        update: (id: string, data: Partial<Omit<T, "_id">>) => dispatch => apiRequest<T>(axios.put(`${this.resourceUrl}/${id}`, data), {
            type: this.actionTypes.UPDATE,
            dispatch
        }),
        create: (data: T) => dispatch => apiRequest<T>(axios.post(this.resourceUrl, data), {
            type: this.actionTypes.CREATE,
            dispatch
        }),
        delete: (id: string) => dispatch => apiRequest<string>(axios.delete(`${this.resourceUrl}/${id}`), {
            type: this.actionTypes.DELETE,
            dispatch
        }),
        clear: () => dispatch => {
            dispatch({
                type: this.actionTypes.CLEAR
            })
        }

    }

    constructor(name: string, path?: string) {
        super(name, path)

        const typeName = name.toUpperCase()
        this.actionTypes = {
            GET: `${typeName}_GET`,
            LIST: `${typeName}_LIST`,
            CREATE: `${typeName}_CREATE`,
            UPDATE: `${typeName}_UPDATE`,
            DELETE: `${typeName}_DELETE`,
            CLEAR: `${typeName}_CLEAR`
        }
    }

}

export function queryBuilder(props: {
    [key: string]: string
}) {

    return "?" + Object.keys(props).map(key => `${key}=${props[key]}`).join("&")
}




